import debounce from 'lodash/debounce';
import * as React from 'react';

type UseResizeParams = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (_?: any) => void;
  debounce?: number;
  immediate?: boolean;
  on: 'x' | 'y' | 'both';
};

export function useResize(params: UseResizeParams): void {
  const refWindowHeight = React.useRef<number>();
  const refWindowWidth = React.useRef<number>();

  const onResize = React.useCallback(
    debounce(() => {
      const prevHeight = refWindowHeight.current;
      const prevWidth = refWindowWidth.current;

      const newHeight = window.innerHeight;
      const newWidth = window.innerWidth;

      const shouldTrigger =
        params.on === 'both' ||
        (params.on === 'y' && prevHeight !== newHeight) ||
        (params.on === 'x' && prevWidth !== newWidth);

      if (shouldTrigger) {
        params.callback();
      }

      refWindowHeight.current = newHeight;
      refWindowWidth.current = newWidth;
    }, params.debounce),
    [params.debounce, params.on],
  );

  React.useEffect(() => {
    if (!params.callback) {
      return;
    }

    if (params.immediate) {
      onResize();
    }

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [params.on]);
}
